import React from 'react';
import PropTypes from 'prop-types';
import InfoIcon from '@material-ui/icons/Info';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import MuiTextField from '@material-ui/core/TextField';

import styles from './styles';

const propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string,
  }).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  touched: PropTypes.bool,
  invalid: PropTypes.bool,
  errMsg: PropTypes.string,
  tooltip: PropTypes.string,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  disabled: PropTypes.bool,
};

const defaultProps = {
  tooltip: '',
  errMsg: '',
  value: '',
  onFocus: () => {},
  onBlur: () => {},
  onChange: () => {},
  invalid: false,
  touched: false,
  disabled: false,
};

const ImageUploadField = props => {
  const {
    classes,
    value,
    onChange,
    onBlur,
    onFocus,
    errMsg,
    touched,
    invalid,
    tooltip,
    disabled,
    reference,
    ...otherProps
  } = props;

  const getInputProps = () => {
    const inputProps = {
      classes: {
        underline: classes.inputUnderline,
        root: classes.inputRoot,
      },
    };
    if (tooltip) {
      inputProps.endAdornment = (
        <InputAdornment position="end">
          <Tooltip
            title={tooltip}
            placement="top"
            classes={{ tooltip: classes.tooltip }}
          >
            <InfoIcon />
          </Tooltip>
        </InputAdornment>
      );
    }
    return inputProps;
  };

  return (
    <MuiTextField
      className={classes.root}
      type="file"
      inputRef={reference}
      // value={value}
      // onChange={(e) => console.log(e.target.files)}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      disabled={disabled}
      InputProps={getInputProps()}
      // eslint-disable-next-line react/jsx-no-duplicate-props
      inputProps={{ accept: 'image/*' }}
      InputLabelProps={{
        classes: {
          root: classes.label,
          focused: classes.labelFocused,
          shrink: classes.labelShrink,
        },
      }}
      FormHelperTextProps={{
        classes: {
          error: classes.errorTextStyle,
        },
      }}
      error={touched && invalid}
      helperText={touched && errMsg}
      style={{ display: 'none' }}
      {...otherProps}
    />
  );
};

ImageUploadField.propTypes = propTypes;
ImageUploadField.defaultProps = defaultProps;

export default withStyles(styles)(ImageUploadField);
